module.exports = vueCompositionApi;